import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IGCCHoldings } from "@/types/IGCCHoldings";
import { getGCCListings } from "@/services/getGCCListings";
import { IGCCListings } from "@/types/IGCCListings";

export const fetchMyListing = createAsyncThunk(
  "/pro/GetGccListings",
  async (
    {
      pageNumber,
      publicAddress,
      searchString,
    }: { pageNumber: number; publicAddress: string; searchString: string }, // Use an object for parameters
    { rejectWithValue }
  ) => {
    try {
      const data = await getGCCListings(
        publicAddress,
        pageNumber,
        searchString
      );
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
interface ListState {
  listing: IGCCListings[];
  pageNumber: number;
  loading: boolean;
  error: string | null;
}

const initialState: ListState = {
  listing: [],
  pageNumber: -1,
  loading: true,
  error: null,
};

export const ListingSlice = createSlice({
  name: "listing_slice",
  initialState,
  reducers: {
    incrementPageNumber: (state) => {
      state.pageNumber += 1;
    },
    resetPageNumber: (state) => {
      state.pageNumber = -1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchMyListing.fulfilled,
        (state, action: PayloadAction<IGCCListings[]>) => {
          const incoming = action.payload;
          const combineData = [...state.listing, ...incoming];
          const uniqueData = combineData.filter(
            (item, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  t.pricePerToken === item.pricePerToken &&
                  t.subject.outId === item.subject.outId
              )
          );
          state.listing = uniqueData;
          state.loading = false;
        }
      )
      .addCase(fetchMyListing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { incrementPageNumber, resetPageNumber } = ListingSlice.actions;

export default ListingSlice.reducer;
